// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-management-container {
  padding: 24px;
  background: #f0f2f5;
  min-height: 100vh;
}

.session-management-header {
  margin-bottom: 24px;
}

.session-management-header h1 {
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: #262626;
}

.session-management-header p {
  font-size: 14px;
  color: #8c8c8c;
  margin: 0;
}

/* Responsive adjustments */

@media (max-width: 768px) {
  .session-management-container {
    padding: 16px;
  }

  .session-management-header h1 {
    font-size: 24px;
  }
}

/* Table customizations */

.session-management-container .ant-table-tbody > tr > td {
  vertical-align: top;
  padding: 12px 16px;
}

.session-management-container .ant-statistic-title {
  font-size: 13px;
  color: #8c8c8c;
  margin-bottom: 8px;
}

.session-management-container .ant-statistic-content {
  font-size: 28px;
  font-weight: 600;
}

/* Card shadows for better visual hierarchy */

.session-management-container .ant-card {
  -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
}

.session-management-container .ant-card:hover {
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  -webkit-transition: -webkit-box-shadow 0.3s ease;
  transition: -webkit-box-shadow 0.3s ease;
  transition: box-shadow 0.3s ease;
  transition: box-shadow 0.3s ease, -webkit-box-shadow 0.3s ease;
}

/* Badge customizations */

.session-management-container .ant-badge-status-text {
  margin-left: 4px;
}

/* Tag customizations */

.session-management-container .ant-tag {
  border-radius: 4px;
  padding: 0 8px;
}

/* Button group spacing */

.session-management-container .ant-space {
  gap: 8px !important;
}

/* Loading spinner */

.session-management-container .ant-spin {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  min-height: 200px;
}
`, "",{"version":3,"sources":["webpack://./pages/SessionManagement/session-management.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,2BAA2B;;AAC3B;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;;AACzB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,6CAA6C;;AAC7C;EACE,iDAAyC;UAAzC,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,iDAAyC;UAAzC,yCAAyC;EACzC,gDAAgC;EAAhC,wCAAgC;EAAhC,gCAAgC;EAAhC,8DAAgC;AAClC;;AAEA,yBAAyB;;AACzB;EACE,gBAAgB;AAClB;;AAEA,uBAAuB;;AACvB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,yBAAyB;;AACzB;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;;AACpB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".session-management-container {\r\n  padding: 24px;\r\n  background: #f0f2f5;\r\n  min-height: 100vh;\r\n}\r\n\r\n.session-management-header {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.session-management-header h1 {\r\n  font-size: 28px;\r\n  font-weight: 600;\r\n  margin: 0 0 8px 0;\r\n  color: #262626;\r\n}\r\n\r\n.session-management-header p {\r\n  font-size: 14px;\r\n  color: #8c8c8c;\r\n  margin: 0;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .session-management-container {\r\n    padding: 16px;\r\n  }\r\n\r\n  .session-management-header h1 {\r\n    font-size: 24px;\r\n  }\r\n}\r\n\r\n/* Table customizations */\r\n.session-management-container .ant-table-tbody > tr > td {\r\n  vertical-align: top;\r\n  padding: 12px 16px;\r\n}\r\n\r\n.session-management-container .ant-statistic-title {\r\n  font-size: 13px;\r\n  color: #8c8c8c;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.session-management-container .ant-statistic-content {\r\n  font-size: 28px;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Card shadows for better visual hierarchy */\r\n.session-management-container .ant-card {\r\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\r\n  border-radius: 8px;\r\n}\r\n\r\n.session-management-container .ant-card:hover {\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);\r\n  transition: box-shadow 0.3s ease;\r\n}\r\n\r\n/* Badge customizations */\r\n.session-management-container .ant-badge-status-text {\r\n  margin-left: 4px;\r\n}\r\n\r\n/* Tag customizations */\r\n.session-management-container .ant-tag {\r\n  border-radius: 4px;\r\n  padding: 0 8px;\r\n}\r\n\r\n/* Button group spacing */\r\n.session-management-container .ant-space {\r\n  gap: 8px !important;\r\n}\r\n\r\n/* Loading spinner */\r\n.session-management-container .ant-spin {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  min-height: 200px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
